module.exports = __webpack_public_path__ + "img/bg-threat-none.3fcc4e47.png";